module.exports = "<ngx-org-chart [nodes]=\"nodes\" direction=\"{{direction}}\" (itemClick)=\"nodeClick($event)\"></ngx-org-chart>"